import { MetricsSectionTitle } from 'components/MetricsSectionTitle';
import { useIntl } from 'react-intl';
import { GroupByToggleGroup } from 'components/GroupByToggleGroup';
import { MetricsChart } from 'components/MetricsChart';
import { LineChartRenderer } from 'components/chart/renderer/LineChartRenderer';
import { Tile, TileContent } from 'components/Layout/PageContainer';
import { Measure } from 'services/model/model.service';

interface TimeSeriesChartPageSectionProps {
  timeSeriesMeasure: Measure;
  timeSeriesRenderer: LineChartRenderer | null;
  dataTestId?: string;
  showGroupByToggle?: boolean;
  trackGroupByToggleEvents?: boolean;
}

export function TimeSeriesChartPageSection({
  timeSeriesMeasure,
  timeSeriesRenderer,
  dataTestId = '',
  showGroupByToggle = true,
  trackGroupByToggleEvents = false,
}: TimeSeriesChartPageSectionProps) {
  const intl = useIntl();
  return (
    <Tile testId={`time-series-chart-${dataTestId}`}>
      <MetricsSectionTitle
        additionalTitle={intl.formatMessage({
          id: 'general.title.over_time',
        })}
        rightComponent={showGroupByToggle ? <GroupByToggleGroup trackEvents={trackGroupByToggleEvents} /> : undefined}
      >
        {`${timeSeriesMeasure.metric.name} `}
      </MetricsSectionTitle>
      <TileContent>
        <MetricsChart renderer={timeSeriesRenderer} height="h-[256px]" />
      </TileContent>
    </Tile>
  );
}
